import { Component, Input } from '@angular/core';
import { DiaryFormElement } from "../../../../../core/models/trial-diary-form/diary-form-element.model";
import { NgIf } from "@angular/common";

@Component({
  selector: 'app-element-label',
  standalone: true,
  imports: [NgIf],
  templateUrl: './element-label.component.html',
  styleUrl: './element-label.component.scss'
})
export class ElementLabelComponent {
  @Input() element: DiaryFormElement;
}
